module.exports = __webpack_public_path__ + "static/scale-model-of-wilbur-d.-may-center-in-reno-nevada-bc19c0916a75edde47cd207041140ed5.png";